import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup, Table,
  Progress,
  Collapse, Button, Fade, Jumbotron,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Input,
  InputGroup,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Form,
  Pagination,
  PaginationItem,
  PaginationLink
} from 'reactstrap';
import moment from 'moment';
import { Link } from "react-router-dom";
import { makeInput, Loading } from "common-import/custom";
import { VarHelper } from "common-import/helpers";

import { inject, observer } from "mobx-react";

import {TicketStatus} from "../../services/ticket/Ticket.Constant";

@inject("ticketStore", "userStore") @observer
class ContractorTicketList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      keyword: "",
      page: 1,
      status: TicketStatus.SUBJECT_WAITING_FOR_RESPONSE,
    }
  }

  async componentDidMount() {
    const { ticketStore } = this.props;
    await this.props.userStore.onReady();
    await ticketStore.getList();
    this.setState({isLoading: false});
  }

  renderRow = (data, index) => {
    return (
      <tr key={"row"+index}>
        <td className="text-center">{index + 1}</td>
        <td>
          <Link to={`/ticket/${data.id}`}>{data.id}</Link>
        </td>
        <td>
          <span>{data.status}</span>
        </td>
        <td>
          <Link target="_blank" to={`/contractor/${data.id}`}>{data.objectId}</Link>
        </td>
        <td>
          <Link target="_blank" to={`/user/${data.id}`}>{data.subjectId}</Link>
        </td>
      </tr>
    )
  };

  render() {
    const { ticketStore } = this.props;
    const listTicket = ticketStore.listTicket.slice();
    if (this.state.isLoading) return (<Loading> </Loading>);
    return (
      <div className="animated fadeIn">
        {/*<Form onSubmit={this.search}>*/}
          {/*<FormGroup row>*/}
            {/*<Col md="12">*/}
              {/*<InputGroup>*/}
                {/*<InputGroupAddon addonType="prepend">*/}
                  {/*<Button type="button" color="primary" onClick={this.search}><i className="fa fa-search"></i> Search</Button>*/}
                {/*</InputGroupAddon>*/}
                {/*{makeInput(this, "keyword")(<Input type="text" id="input1-group2" name="input1-group2" placeholder="Nhập tên để tìm nhà thầu đã xác thực" />)}*/}
              {/*</InputGroup>*/}
            {/*</Col>*/}
          {/*</FormGroup>*/}
        {/*</Form>*/}
        <div className="form">
          <div className="form-group">
            <select value={this.state.status} className="form-control" onChange={(e) => this.setState({status: e.target.value}, () => this.props.ticketStore.getList(1, this.state.status))}>
              {
                Object.entries(TicketStatus).map(([key, value]) => {
                  return <option key={key} value={value}>{value}</option>
                })
              }
            </select>
          </div>
        </div>
        <Row>
          <Col xs="12" sm="12">
            <Table hover responsive className="table-outline mb-0 d-sm-table">
              <thead className="thead-light">
              <tr>
                <th className="text-center"><i className="fa fa-ticket"> </i></th>
                <th>Ticket</th>
                <th>Status</th>
                <th>Contractor</th>
                <th>User</th>
              </tr>
              </thead>
              <tbody style={{backgroundColor: 'white'}}>
              {listTicket.length > 0 && listTicket.map((val, index) => this.renderRow(val, index))}
              </tbody>
            </Table>
            {listTicket.length === 0 && <p style={{ marginTop: 20, testAlign: "center", display: "block" }}>Have no contractor need to claim</p>}
          </Col>
        </Row>
        <Row style={{marginTop: 20, marginBottom: 20}}>
          <Col xs="12" md="12">
            <Pagination>
              <PaginationItem>
                <PaginationLink previous onClick={this.loadPrev}/>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink>{this.state.page}</PaginationLink>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink next onClick={this.loadNext} />
              </PaginationItem>
            </Pagination>
          </Col>
        </Row>
      </div>
    );
  }

  search = e => {
    !!e && e.preventDefault();
    const { ticketStore } = this.props;
    const { keyword } = this.state;
    if(keyword === "") {
      // ticketStore.getList();
    } else {
      // ticketStore.search(keyword, 1);
    }
  };

  loadPrev = e => {
    !!e && e.preventDefault();
    if(this.state.page === 1) return;
    const { ticketStore } = this.props;
    this.setState({ page: this.state.page - 1}, () => {
      ticketStore.getList(this.state.page, this.state.status);
    });
  };

  loadNext = e => {
    !!e && e.preventDefault();
    const { ticketStore } = this.props;
    this.setState({ page: this.state.page + 1}, () => {
      ticketStore.getList(this.state.page, this.state.status);
    });
  }
}

export default ContractorTicketList;



// WEBPACK FOOTER //
// ./src/views/Contractors/TicketList.js